module.exports = require("typescript");